import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";

import { Checkbox } from "primereact/checkbox";
import BottomMessagePopUp from "../../../components/BottomMessagePopUp";
import useGetToken from "../../../store/selectors/get-token";
import useGetOrderDetailsId from "../../../store/selectors/get-order-details";
import { updateHealthEntry } from "../../../utils/backend";
import { useTranslation } from 'react-i18next';

const DeclarationTwo = () => {
	const { t } = useTranslation();
	const [agreement, setAgreement] = useState(false);
	const [agreeReceive, setAgreeReceive] = useState(false);
	const navigate = useNavigate();
	const token = useGetToken();
	const getOrderDetails = useGetOrderDetailsId();
	const [errorMessage, setErrorMessage] = useState("");
	const [isErrorVisible, setIsErrorVisible] = useState(false);
	const showErrorMessage = (msg) => {
		setErrorMessage(msg);
		setIsErrorVisible(true);
	};

	const submitSelectedPlan = async (e) => {
		e.preventDefault();
		
		if (!agreement) {
			showErrorMessage(`${t("messages.haveToAgreeTerms")}`);
			return;
		}

		const payload = {
			health_id: getOrderDetails.productId,
			health_data: {
				agree_life_declaration_2: agreement
			}
		};
		
		try {
			const response = await updateHealthEntry(token, payload);
			
			if (response.success) {
				navigate(`/get-health-quotes/health-payments`);
			} else {
				showErrorMessage(`${t("common.error")}.` + response.message);
				return;
			}
		} catch (error) {
			showErrorMessage(`${t("messages.errorWhileSubmittingDetails")}`);
			return;
		}
	};

	const onAgreementChange = (e) => {
		setAgreement(e.checked);
		localStorage.setItem("declarationTwoA1", JSON.stringify(e.checked));
	};

	const onAgreeReceiveChange = (e) => {
		setAgreeReceive(e.checked);
		localStorage.setItem("declarationTwoA2", JSON.stringify(e.checked));
	};

	useEffect(() => {
		const cachedAgreementOne = localStorage.getItem("declarationTwoA1");
		const cachedAgreementTwo = localStorage.getItem("declarationTwoA2");

		if (cachedAgreementOne) setAgreement(JSON.parse(cachedAgreementOne));
		if (cachedAgreementTwo) setAgreeReceive(JSON.parse(cachedAgreementTwo));
	}, []);

	return (
		<>
			<div className="content px-2">
				<div className="get-quote-process-container vw-50">
					<div className="d-flex w-100">
						<div className="d-flex flex-column">
							<h3 className="mb-0">{`${t("healthInsurance.declarationTwo.title")}`}</h3>
							<div className="d-flex flex-row align-items-center vw-100">
								<span className="color-heading fw-bold my-2">
									{`${t("healthInsurance.declarationTwo.subTitle")}`}
								</span>
							</div>

							<ol className="px-4">
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.1")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.2")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.3")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.4")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.5")}`}</li>
								<li className="text-justify color-heading my-4">{`${t("healthInsurance.declarationTwo.points.6")}`}</li>
							</ol>

							<div className="mb-2">
								<div className="flex">
									<Checkbox
										inputId="agreement"
										name="agreement"
										value={agreement}
										onChange={onAgreementChange}
										checked={agreement}
									/>
									<label htmlFor="agreement" className="ml-2">
										{`${t("healthInsurance.declarationTwo.agreement1")}`}
									</label>
								</div>
							</div>

							<div className="mb-4">
								<div className="flex">
									<Checkbox
										inputId="agreement"
										name="agreement"
										value={agreeReceive}
										onChange={onAgreeReceiveChange}
										checked={agreeReceive}
									/>
									<label htmlFor="agreement" className="ml-2">
										{`${t("healthInsurance.declarationTwo.agreement2")}`}
									</label>
								</div>
							</div>
						</div>

						<Button
							label={`${t("common.proceed")} (6/7)`}
							className="btn-primary"
							onClick={(e) => submitSelectedPlan(e)}
						/>

						{/* BottomMessagePopUp Component */}
						<BottomMessagePopUp
							message={errorMessage}
							type="error"
							isVisible={isErrorVisible}
							onClose={() => setIsErrorVisible(false)}
						/>
					</div>
				</div>
			</div>
		</>
	);
};

export default DeclarationTwo;
